import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { IntlProvider } from "react-intl";

import AppLayout from "./AppLayout";
import AppLocale from "../lngProvider";
import asyncComponent from '../util/asyncComponent';
import indigoTheme from "./themes/indigoTheme";
import MomentUtils from "@date-io/moment";
import RTL from "util/RTL";
import { RedirectDefaultRoute } from '../app/routes/util'
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import { setIsMobileDevice } from 'actions/Setting';
import { settingsAllSelector } from 'selectors';

import "assets/vendors/style";

const App = (props) => {
  const dispatch = useDispatch();
  const { locale, isDirectionRTL, isMobileDevice } = useSelector(settingsAllSelector);
  const { match, location } = props;
  const [portraitMatchMedia] = useState(window.matchMedia('only screen and (max-width: 500px) and (max-height: 900px) and (orientation: portrait)'));
  const [landscapeMatchMedia] = useState(window.matchMedia('only screen and (max-width: 900px) and (max-height: 500px) and (orientation: landscape)'));

  useEffect(() => {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
  }, []);

  // keep track of app width for sidebar
  useEffect(() => {
    let watchTimer;
    
    // set default at load
    dispatch(setIsMobileDevice(portraitMatchMedia.matches || landscapeMatchMedia.matches));
    
    const watchResizeDebounce = () => {
      clearTimeout(watchTimer);
      watchTimer = setTimeout(() => {
        // need to check if matches to avoid app redraw from updating 'settings' store
        const isMobileCheck = portraitMatchMedia.matches || landscapeMatchMedia.matches;
        if (isMobileCheck !== isMobileDevice) {
          dispatch(setIsMobileDevice(isMobileCheck));
        }
      }, 100);
    }
    window.addEventListener('resize', watchResizeDebounce);

    return () => {
      window.removeEventListener('resize', watchResizeDebounce);
    }
  }, [isMobileDevice]);

  let applyTheme = createMuiTheme(indigoTheme);

  if (location.pathname === '/') {
    const isMobileDevice = portraitMatchMedia.matches || landscapeMatchMedia.matches;
    return ( <RedirectDefaultRoute isMobileDevice={isMobileDevice } /> );
  }

  if (isDirectionRTL) {
    applyTheme.direction = 'rtl';
    document.body.classList.add('rtl')
  } else {
    document.body.classList.remove('rtl');
    applyTheme.direction = 'ltr';
  }

  const currentAppLocale = AppLocale[locale.locale];

  return (
    <ThemeProvider theme={applyTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}>
          <RTL>
            <div className="app-main">
              <Switch>
                {/* /print/* routes use the print layout - no header, footer, sidebar, nav, etc */}
                <Route path={`${match.url}print`} render={(props) => { return <AppLayout {...props} layoutOverride="Print" /> }}/>
                {/* default app layout */}
                <Route path={`${match.url}app`} component={AppLayout}/>
                <Route component={asyncComponent(() => import('../app/routes/404Page'))}/>
              </Switch>
            </div>
          </RTL>
        </IntlProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};


export default App;
